import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {
  getPartnerIdFromState,
  getTenantPartnerIdFromState,
} from './partnerStateSelectors'
import { useUserType } from './useUserType'
import type { CrmOnboardingRootState } from '../../modules/crmSelector/crmOnboardingState'

const useSafeLocation = (): string => {
  try {
    const location = useLocation()
    return location.pathname
  } catch {
    if (typeof window !== 'undefined' && window.location) {
      return window.location.pathname
    }
    return ''
  }
}

export const useOnboardingTenantPartnerId = () => {
  const userType = useUserType()
  const pathname = useSafeLocation()
  return useSelector((state: CrmOnboardingRootState) =>
    getTenantPartnerIdFromState(state, userType, pathname)
  )
}

export const useOnboardingAccountId = () => {
  const userType = useUserType()
  const pathname = useSafeLocation()
  return useSelector((state: CrmOnboardingRootState) =>
    getPartnerIdFromState(state, pathname, userType)
  )
}

export const useOnboardingCrmType = () => {
  const userType = useUserType()
  return useSelector(
    (state: CrmOnboardingRootState) =>
      state.AccountData?.[userType]?.partnerData?.crmType || null
  )
}
